import { Roles } from 'enums/roles'
import { StatiPratica } from 'enums/stati-pratica'

export const statiModificaPermessa = [
  StatiPratica.IN_RICHIESTA.stato,
  StatiPratica.IN_LAVORAZIONE.stato,
  StatiPratica.CHECK_OUT_OPERATORE.stato,
  StatiPratica.INFO_COMPLETE.stato
]

export const statiModificaAnagraficaECampi = [
  StatiPratica.IN_RICHIESTA.stato,
  StatiPratica.IN_LAVORAZIONE.stato,

]